import { jsx as _jsx } from "react/jsx-runtime";
var Checkmark = function Checkmark(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M9.863 18a1 1 0 0 1-.729-.315l-4.863-5.179a1 1 0 1 1 1.457-1.369l4.125 4.391 8.408-9.202a1 1 0 0 1 1.477 1.348l-9.137 10a.998.998 0 0 1-.73.326h-.008Z",
      fill: color
    })
  });
};
export default Checkmark;